"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = get;

var _toPath = _interopRequireDefault(require("./_toPath.js"));

var _deepGet = _interopRequireDefault(require("./_deepGet.js"));

var _isUndefined = _interopRequireDefault(require("./isUndefined.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = (0, _deepGet.default)(object, (0, _toPath.default)(path));
  return (0, _isUndefined.default)(value) ? defaultValue : value;
}